import cookies from 'browser-cookies';

const URL: string = import.meta.env.VITE_APPS_API_URL || '';
const TOKEN_ENVIRONMENT = {
  stage: 'trak_auth_s',
  prod: 'trak_auth_p',
  development: 'trak_auth_d',
}[import.meta.env.VITE_ENVIRONMENT_NAME || 'development'] || 'trak_auth_d';

class API {
  static getHeader() {
    const trackAuth = cookies.get(TOKEN_ENVIRONMENT) || '';

    const baseHeaders = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      authorization: trackAuth.split(',')[0],
    };

    if (import.meta.env.VITE_NGROK_SKIP_BROWSER_WARNING) {
      return {
        ...baseHeaders,
        'ngrok-skip-browser-warning': 'yes please',
      };
    }

    return baseHeaders;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static paramsToURLParams(params: any, mainProperty = '') {
    return Object.keys(params)
      .map((prop) => {
        let query = '';
        if (typeof params[prop] === 'object' && params[prop]) {
          query = API.paramsToURLParams(params[prop], prop);
        } else {
          if (mainProperty) {
            query = `${mainProperty}[${prop}]=${params[prop]}`;
          } else {
            query = `${prop}=${params[prop]}`;
          }
        }
        return query;
      })
      .join('&');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async get<T = any>(url: string, body: any = {}): Promise<T> {
    let query = '';
    if (body) {
      query = this.paramsToURLParams(body);
    }

    return fetch(`${URL}${url}?${query}`, {
      method: 'GET',
      headers: API.getHeader(),
    })
      .then(API.hasAccessDenied)
      .then(API.toJson) as Promise<T>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async post<T = any>(url: string, body: any): Promise<T> {
    return fetch(`${URL}${url}`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: API.getHeader(),
    })
      .then(API.hasAccessDenied)
      .then(API.toJson) as Promise<T>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async put<T = any>(url: string, body: any): Promise<T> {
    return fetch(`${URL}${url}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: API.getHeader(),
    })
      .then(API.hasAccessDenied)
      .then(API.toJson) as Promise<T>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async patch<T = any>(url: string, body: any): Promise<T> {
    return fetch(`${URL}${url}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: API.getHeader(),
    })
      .then(API.hasAccessDenied)
      .then(API.toJson) as Promise<T>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async delete<T = any>(url: string, body: any): Promise<T> {
    return fetch(`${URL}${url}`, {
      method: 'DELETE',
      body: JSON.stringify(body),
      headers: API.getHeader(),
    })
      .then(API.hasAccessDenied)
      .then(API.toJson) as Promise<T>;
  }

  static async hasAccessDenied(response: Response) {
    const responseCopy = response.clone();
    if (!responseCopy.ok) {
      const result = await API.toJson(responseCopy);
      if (result?.statusCode === 403) {
        window.location.href = `${import.meta.env.VITE_ONFLEET_URL}login`;
      }
    }
    return response;
  }

  static async toJson(response: Response) {
    return response.json().catch(() => {});
  }
}

export default API;
